export const FLAG_GETTING_BUSINESSES = 'FLAG_GETTING_BUSINESSES';
export const GET_BUSINESSES = 'GET_BUSINESSES';
export const CLEAR_BUSINESSES = 'CLEAR_BUSINESSES';
export const FLAG_BUSINESS_ACTIVITY = 'FLAG_BUSINESS_ACTIVITY';
export const GET_BUSINESS = 'GET_BUSINESS';
export const CLEAR_BUSINESS = 'CLEAR_BUSINESS';
